import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-input-form-default',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
})
export class InputFormComponent {
    @Input() label: string | undefined;
    @Input() value: string | undefined = '';
    @Input() _index: number | any = 0;
    @Input() showIsValidLabel: boolean = true;
    @Input() showIsInValidLabel: boolean = true;
    @Input() isValid: boolean = false;
    @Input() isInvalid: boolean = false;
    @Input() isValidFeedBack: string = '';
    @Input() isInvalidFeedBack: string = '';
    @Input() type: string = 'text';
    @Input() classCustom: string = '';
    @Input() icon: string = '';

    @Input() placeHolder = '';

    @Output() inputChange = new EventEmitter();

    public passwordVisible: boolean = false;

    public get isPassword(): boolean {
        return this.type === 'password';
    }

    public togglePasswordVisibility(): void {
        this.passwordVisible = !this.passwordVisible;
    }

    public getValue(event: Event): string {
        return (event.target as HTMLInputElement).value;
    }

    public emit(value: any): void {
        this.inputChange.emit(value);
    }
}
